import React, {useEffect} from 'react'

import Navbar from '../Navbar';
import Footer from '../footer';
import Filtering from './Filtering';
import Herosection from './Herosection';
import OurVision from './OurVision';
import WhyChooseUs from './WhyChooseUs';
import BackToTop from '../BackToTop';


const AboutPage = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}, []);
  return (
    <section>
      <Navbar />

      <Herosection />

      <OurVision />

      <WhyChooseUs />

      <Filtering />

      <Footer />

      <BackToTop />
    </section>
  )
}

export default AboutPage;